import type { ReactNode } from "react";
import { useReveal } from "../../hooks/useReveal";

interface SectionProps {
  id: string;
  children: ReactNode;
  className?: string;
}

// Section wrapper with consistent spacing + scroll-reveal.
export default function Section({ id, children, className = "" }: SectionProps) {
  const ref = useReveal<HTMLElement>();
  return (
    <section
      id={id}
      ref={ref}
      className={`relative mx-auto w-full max-w-6xl px-5 py-20 sm:px-8 sm:py-28 ${className}`}
    >
      {children}
    </section>
  );
}

interface HeadingProps {
  tag: string;
  title: string;
  subtitle?: string;
}

export function SectionHeading({ tag, title, subtitle }: HeadingProps) {
  return (
    <div className="mb-12 max-w-2xl">
      <span className="mb-3 inline-flex items-center gap-2 rounded-full border border-soft px-3 py-1 text-xs font-semibold uppercase tracking-widest text-cyan-400">
        <span className="h-1.5 w-1.5 rounded-full bg-cyan-400" />
        {tag}
      </span>
      <h2 className="font-display text-3xl font-bold leading-tight sm:text-4xl">{title}</h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-soft sm:text-lg">{subtitle}</p>}
    </div>
  );
}
